<script setup lang="ts">
interface Banner {
  image: string;
  action: string;
  action_type: string;
}

const props = defineProps<{
  banner?: Banner;
  games: any[];
  title: string;
}>();

const gamesData = ref(props.games);

watch(
  () => props.games,
  (newGames) => {
    gamesData.value = newGames;
  },
  { immediate: true },
);
</script>

<template>
  <header v-if="props.banner">
    <NuxtLink
      no-prefetch
      :target="props.banner?.action_type !== 'route' ? '_blank' : '_self'"
      :to="props.banner?.action"
    >
      <img
        alt="banner"
        class="relative mb-5 cursor-pointer rounded-[4px] w-full"
        :src="props.banner?.image"
      />
    </NuxtLink>
  </header>
  <div class="mt-6 mb-6 sm:mb-2 flex items-center xl:pb-1">
    <button
      class="flex items-center bg-transparent text-texts/60"
      @click="$router.back()"
    >
      <NuxtIcon
        class="flex-none"
        name="arrows/arrow_left"
      />
    </button>

    <div
      class="inline ml-3 text-[.9rem] text-texts font-semibold"
      v-html="props.title"
    >
    </div>
  </div>
  <div class="games">
    <section class="spacing">
      <div class="games_content">
        <CasinoMediaList
          display-mode="list"
          :items="gamesData"
          :per-row="{ 768: 3, 1100: 4, 1200: 5, desktop: 6 }"
        />
      </div>
    </section>
  </div>
</template>

<style scoped lang="scss">
.games {
  @apply flex flex-col xl:pt-5;

  .spacing {
    @apply p-3 pt-0 px-0;
  }

  .games_content {
    .bt_link {
      @apply bg-white text-black py-3 px-5 rounded-md text-base gap-2 inline-flex m-0 items-center justify-center shadow-md hover:opacity-90 hover:text-primary whitespace-nowrap w-auto;
    }
  }
}
</style>
